
import { Box, Link, Tooltip } from '@mui/material'
import { CustomColumnGridConfig } from '../types'
import link from '@assets/ConsumerHistory/link.svg'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
dayjs.extend(customParseFormat)

const pickFromDate = (row: any) => row.fromDate ?? row.startDate ?? row.from
const pickToDate = (row: any) => row.toDate ?? row.endDate ?? row.to
const pickReason = (row: any) => row.replaceReason ?? row.reason ?? row.cause

const clean = (s?: string) => (s ? s.replace(/\u200f|\u200e/g, '').trim() : '')

const fmt = (v: any) => {
  if (!v) return '-'
  if (v instanceof Date && !isNaN(v.getTime())) {
    return dayjs(v).format('DD/MM/YYYY')
  }
  if (typeof v === 'string') {
    const s = clean(v)
    if (!s || s === '—' || s === '-') return '-'
    const head = s.split('–')[0].split('-')[0].trim()
    const d = dayjs(head, 'DD/MM/YYYY', true)
    return d.isValid() ? d.format('DD/MM/YYYY') : head
  }
  return '-'
}

const historyColumns: CustomColumnGridConfig[] = [
  {
    field: 'fromDate',
    headerName: 'מתאריך',
    minWidth: 140,
    flex: 1,
    filter: { type: 'date' },
    filterable: true,
    renderCell: (params: any) => fmt(pickFromDate(params.row)),
  },
  {
    field: 'toDate',
    headerName: 'עד תאריך',
    minWidth: 140,
    flex: 1,
    filter: { type: 'date' },
    filterable: true,
    renderCell: (params: any) => fmt(pickToDate(params.row)),
  },
  {
    field: 'meterNumber',
    headerName: "מס' מד",
    minWidth: 140,
    flex: 1,
    filter: { type: 'search' },
    filterable: true,
  },
  {
    field: 'reason',
    headerName: 'סיבת החלפה',
    minWidth: 160,
    flex: 1.2,
    filter: { type: 'options' },
    filterable: true,
    renderCell: (params: any) => pickReason(params.row) ?? '-',
  },
  {
    field: 'report',
    headerName: 'דו״ח החלפה',
    width: 160,
    align: 'center',
    headerAlign: 'center',
    sortable: false,
    filter: { type: 'none' },
    renderCell: () => {
      const url =
        'https://reader.madrimonim.co.il/v/Ow1PAAAAAACZ9cTzA5-9rbrsXNsj-LToWX4D5w'
      return (
        <Tooltip title="פתיחת דו״ח החלפה">
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <Link href={url} underline="hover" color="#0022FF">
              דו״ח החלפה
            </Link>
            <img
              src={link}
              alt="דו״ח"
              style={{ width: 18, height: 18, objectFit: 'contain' }}
            />
          </Box>
        </Tooltip>
      )
    },
  },
]

export default historyColumns
